import {Grid} from "@mui/material";
import {RootState} from "../../../Config/Store";
import {useAppSelector} from "../../../Config/Hooks";
import GenerationChart from "./GenerationChart/GenerationChart";
import PowerVSIrradianceChart from "./PowerVSIrradianceChart/PowerIrradianceChart";
import PowerPUForInvertersChart from './PowerPUForInvertersChart/PowerPUForInvertersChart';
import GenerationPRChartPlant from "./GenerationPRChartPlant/GenerationPRChartPlant";
import ErrorBoundaryChart from "../../../Shared/Error/ErrorBoudaryChart";
import GenerationRateAndComparisonSkids from "./GenerationRateAndComparisonSkidsChart/GenerationRateAndComparisonSkids";
import PowerStationInformation from "./PowerStationInformation/PowerStationInformation";
import {QueryClient, QueryClientProvider} from "react-query";
import InstantData from "./InstantData/InstantData";
import TicketWidget from "../Ticket/TicketWidget";
import { hasPermission } from "../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../Config/Constants";
import { ASectionTitle } from "@atiautomacao/ati-ui-library";

export default function DashboardPowerPlantChartsPage() {

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSearch = hasPermission(account?.authoritySet, [ AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_TICKET ]);
    const {selectedPowerPlant} = useAppSelector((state: RootState) => state.dashboard);
    const queryClient = new QueryClient();

    return (
        <Grid container spacing={'24px'} paddingLeft={'24px'} paddingRight={'24px'} paddingBottom={'24px'}>
            <Grid item xs={12} md={12} lg={12} xl={12} style={{paddingRight: 24}}>
                <QueryClientProvider client={queryClient}>
                    <PowerStationInformation powerStation={selectedPowerPlant} />
                </QueryClientProvider>
            </Grid>
             <Grid item xs={12} style={{paddingRight: 24}}>
                <ASectionTitle
                    styleContainer={{ padding: '8px 0px 0px' }} 
                    titleLabel="Gráficos de Atividade"/>
            </Grid>
            { window.innerWidth > 1024 ?

                <>
                    <Grid item xs={12} sm={12} md={12} lg={10} xl={10} style={{paddingRight: 24}}>
                        <ErrorBoundaryChart chartName={"Energia Gerada"}>
                            <GenerationChart powerPlant={selectedPowerPlant} />
                        </ErrorBoundaryChart>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} style={{paddingRight: 24}}>
                        <ErrorBoundaryChart chartName={"Dados instantâneos"}>
                            <QueryClientProvider client={queryClient}>
                                <InstantData powerPlant={selectedPowerPlant} />
                            </QueryClientProvider>
                        </ErrorBoundaryChart>
                    </Grid>
                </>
                :

                <>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} style={{paddingRight: 24}}>
                        <ErrorBoundaryChart chartName={"Dados instantâneos"}>
                            <QueryClientProvider client={queryClient}>
                                <InstantData powerPlant={selectedPowerPlant} />
                            </QueryClientProvider>
                        </ErrorBoundaryChart>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={10} xl={10} style={{paddingRight: 24}}>
                        <ErrorBoundaryChart chartName={"Energia Gerada"}>
                            <GenerationChart powerPlant={selectedPowerPlant} />
                        </ErrorBoundaryChart>
                    </Grid>
                </>
            }

            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Potência por inversor (PU)"}>
                    <PowerPUForInvertersChart powerPlant={selectedPowerPlant} />
                </ErrorBoundaryChart>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Potência x Irradiância"}>
                    <QueryClientProvider client={queryClient}>
                        <PowerVSIrradianceChart powerPlant={selectedPowerPlant} />
                    </QueryClientProvider>
                </ErrorBoundaryChart>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Comparativo de Skids"}>
                    <GenerationRateAndComparisonSkids powerPlant={selectedPowerPlant}/>
                </ErrorBoundaryChart>
            </Grid>
            
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{paddingRight: 24}}>
                <ErrorBoundaryChart chartName={"Performance Ratio (%)"}>
                    <GenerationPRChartPlant powerPlant={selectedPowerPlant}  />
                </ErrorBoundaryChart>
            </Grid>
            { isAuthorizedToSearch &&
                <Grid item xs={12} md={12} xl={12} style={{paddingRight: 24}}>
                    <ErrorBoundaryChart chartName={"Tickets"}>
                        <TicketWidget searchParams={{ powerStationId: selectedPowerPlant.id }}/>
                    </ErrorBoundaryChart>
                </Grid>
            }
        </Grid>
    );
}